import { Component, OnDestroy } from '@angular/core';
import { ConfigurableDialog, DialogService } from '@proget-shared/dialog';
import { ToastService } from '@proget-shared/ui/toast';
import { noop, Subscription } from 'rxjs';

import { AccountSettingsRepository } from '../../account-settings.repository';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  standalone: false,
})
export class TermsOfUseComponent implements OnDestroy, ConfigurableDialog {
  protected content: string;
  protected confirmed = false;

  private readonly subscription = new Subscription();

  constructor(
    private accountSettingsRepository: AccountSettingsRepository,
    private dialogService: DialogService,
    private toastService: ToastService
  ) {
    this.subscription.add(
      this.accountSettingsRepository.getTermsOfUse()
        .subscribe({
          next: (content) => {
            this.content = content;
          },
          error: () => {
            this.toastService.error('toast.internal_error.title', 'toast.internal_error.description');
            this.close();
          },
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onConfiguration({ confirmed }: any): void {
    this.confirmed = confirmed;
  }

  protected accept(): void {
    this.accountSettingsRepository.acceptTermsOfUse().subscribe({
      next: () => {
        this.dialogService.resolve(this, true);
      },
      error: noop,
    });
  }

  protected reject(): void {
    this.dialogService.resolve(this, false);
  }

  protected close(): void {
    this.dialogService.reject(this);
  }
}
